import { render, staticRenderFns } from "./OtherInformationView.vue?vue&type=template&id=2e39c47f&scoped=true"
import script from "./OtherInformationView.vue?vue&type=script&lang=js"
export * from "./OtherInformationView.vue?vue&type=script&lang=js"
import style0 from "./OtherInformationView.vue?vue&type=style&index=0&id=2e39c47f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e39c47f",
  null
  
)

export default component.exports